import {DecimalPipe} from '@angular/common'
import {Component, input, OnChanges, OnInit, signal} from '@angular/core'
import {MatCheckbox} from '@angular/material/checkbox'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {BaseTable} from '@sparbanken-syd/sparbanken-syd-theme'
import {MatSort, MatSortHeader} from '@angular/material/sort'
import {ValueComponent} from './value/value.component'
import {IStatistics} from '../../../services/types'

@Component({
  selector: 'spb-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatCheckbox,
    DecimalPipe,
    MatSort,
    MatSortHeader,
    ValueComponent
  ]
})
export class TableComponent extends BaseTable<IStatistics> implements OnInit, OnChanges {
  /**
   * The range to show. A string in (e.g.) 'week', 'day' all etc.
   */
  public range = input('week')

  /**
   * The data set to display. Made as a selector so that it updates externally.
   * 'year' is special since it cannot be sorted.
   *
   * @param data - The data to display.
   */
  public data = input<IStatistics[]>([])

  /**
   * A simple checkbox that tells if we should show (or not) percentages in the table.
   */
  public hidePercent = signal(false)

  /**
   * The title to show on the tab. Selected based on the range input below.
   */
  public rangeTitle = 'Vecka'

  private readonly rangeTitleMap = {
    week: 'Vecka',
    month: 'Månad',
    year: 'År',
    weekday: 'Veckodag',
    day: 'Dag',
    age: 'Ålder',
    risk: 'Risk',
    all: 'Alla'
  }

  constructor() {
    super()
    this.columns.set(['total', 'auto_total',
      'approved', 'rejected', 'kalp', 'uc', 'income', 'pending', 'declined', 'amount'])
  }

  public ngOnInit(): void {
    this.columns.update(columns => {
      columns.unshift(this.range())
      return columns
    })
    this.rangeTitle = this.rangeTitleMap[this.range()]
    // Remove the first column since it is only one
    if (this.range() === 'all') {
      this.columns.update(columns => {
        columns.shift()
        return columns
      })
    }
  }

  public ngOnChanges(): void {
    // This has to be sorted "natural sort", however that
    // is too complicated, so we cheat.
    const data = this.data()
    if (this.range() === 'age') {
      data.sort((a: IStatistics, b: IStatistics) =>
        a.key.localeCompare(b.key, 'sv-SE', {numeric: true}))
    }

    if (this.range() === 'risk' || this.range() === 'week') {
      data.sort((a, b) => a.key.localeCompare(b.key))
    }

    // Sunday is NOT the first day of week.
    if (this.range() === 'weekday') {
      data.push(this.data().splice(0, 1)[0])
    }

    if (this.range() === 'year') {
      data.sort((a: IStatistics, b: IStatistics) => b.year - a.year)
    }
    this.items.data = data
  }

  /**
   * For the future when we implement a totals row.
   *
   * @param checked - currently only checkbox is supported
   * @param key - A selector for selecting what to summarize.
   */
  public getTotal = (checked: boolean, key: string): number => {
    if (key === 'percent') {
      this.hidePercent.set(checked)
    }
    return Number.parseInt(key, 10)
  }
}
